var UitkListOrientationMap = [
    ['inline', 'orientation-inline'],
    ['stacked', 'orientation-stacked']
];
var UitkListOrientations = new Map(UitkListOrientationMap);
var UitkListSizeMap = [
    [1, 'size-1'],
    [2, 'size-2'],
    [3, 'size-3']
];
var UitkListSizes = new Map(UitkListSizeMap);
var UitkListTypeMap = [
    ['unordered', 'ul'],
    ['ordered', 'ol']
];
var UitkListTypes = new Map(UitkListTypeMap);
var UitkListBulletMap = [
    ['default', 'bullet-default'],
    ['no-bullet', 'bullet-none'],
    ['icon-alternate', 'bullet-icon-alternate'],
    ['icon-standard', 'bullet-icon-standard'],
    ['tiered-numbered', 'bullet-tiered-numbered']
];
var UitkListBullets = new Map(UitkListBulletMap);
var UitkListItemThemeMap = [
    ['default', 'default-theme'],
    ['emphasis', 'emphasis-theme'],
    ['positive', 'positive-theme'],
    ['negative', 'negative-theme']
];
var UitkListItemThemes = new Map(UitkListItemThemeMap);

export { UitkListBullets, UitkListItemThemes, UitkListOrientations, UitkListSizes, UitkListTypes };
